
import CloseIcon from "@mui/icons-material/Close";
import { Button, Dialog } from "@mui/material";
import { useMemo, useState } from "react";
import RichTextEdit from "../editors/RichTextEdit";
import { coerceRichTextValue } from "../utils/richTextValue";

const PreviewHtml = ({
    label,
    value,
    inline = false,
}: {
    label?: string;
    value: unknown;
    inline?: boolean;
}) => {
    const [open, setOpen] = useState(false);
    const previewValue = useMemo(() => coerceRichTextValue(value).trim(), [value]);
    const hasValue = previewValue.length > 0;
    const title = label ? `${label} preview` : "Rich text preview";
    const inlineMaxWidth = "max-w-[min(100%,360px)]";
    const containerClass = inline
        ? `relative inline-block min-w-0 align-top ${inlineMaxWidth}`
        : "relative w-full min-w-0";
    const previewClass = inline
        ? `richtext-preview overflow-hidden break-words ${inlineMaxWidth} [&_img]:max-w-full [&_table]:max-w-full [&_video]:max-w-full`
        : "richtext-preview w-full max-w-full overflow-hidden break-words [&_img]:max-w-full [&_table]:max-w-full [&_video]:max-w-full";

    return (
        <>
            <div className={containerClass}>
                <div
                    className={`rounded border border-slate-200 bg-white p-2 text-sm text-slate-700 ${hasValue ? "max-h-28 overflow-hidden" : ""
                        }`}
                >
                    {hasValue ? (
                        <div
                            className={previewClass}
                            dangerouslySetInnerHTML={{ __html: previewValue }}
                        />
                    ) : (
                        <span className="text-xs text-slate-400">No content</span>
                    )}
                </div>
                {hasValue && (
                    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-8 bg-gradient-to-t from-white to-transparent" />
                )}
                <div className="mt-1 flex justify-end">
                    <Button
                        size="small"
                        variant="text"
                        onClick={() => setOpen(true)}
                        disabled={!hasValue}
                    >
                        Open preview
                    </Button>
                </div>
            </div>

            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <div className="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-3">
                    <div className="text-sm font-semibold text-slate-800">{title}</div>
                    <Button
                        onClick={() => setOpen(false)}
                        variant="text"
                        size="small"
                        aria-label="Close preview"
                    >
                        <CloseIcon fontSize="small" />
                    </Button>
                </div>
                <div className="bg-white p-4">
                    <RichTextEdit
                        name={label || ""}
                        value={previewValue}
                        onChange={() => { }}
                        readOnly
                    />
                </div>
            </Dialog>
        </>
    );
};

export default PreviewHtml;
